import React, { useState } from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";

import calendarioIcon from "../calendario.png";
import selezionaIcon from "../seleziona.png";
import okIcon from "../ok.png";
import cartaIcon from "../carta.png";
import flagIT from "../italy.png";
import flagEN from "../united-kingdom.png";
import flagFR from "../france.png";
import flagDE from "../germany.png";
import backgroundImage from "../back2.jpg";

const TariffeAbbonamenti = () => {
  const [language, setLanguage] = useState("it");

  const translations = {
    it: {
      title: "Tariffe",
      reservationTitle: "Prenotazioni",
      priceNote:
        "I = Intera giornata, M = Mezza giornata (8:00–13:00 o 13:30–18:30). Esempio: I: €20.00 M: €15.00",
      reservationHighlight:
        "È possibile prenotare il proprio posto in spiaggia andando su",
      points: [
        "Nella sezione 'Prenotazioni' si accede alla mappa dalla quale è possibile selezionare l’ombrellone desiderato.",
        "Possibilità di prenotare fino alle 24:00 del giorno precedente.",
        "Posto garantito.",
        "Scelta dell’ombrellone facile ed intuitiva.",
        "Pagamento anticipato con carta.",
      ],
      months: [
        {
          mese: "MAGGIO",
          dettagli: {
            periodo: "1-31 MAGGIO (incluso il sabato e la domenica)",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "GIUGNO",
          dettagli: {
            periodo: "1-30 GIUGNO (escluso il sabato e la domenica)",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€25.00 / €18.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€33.00 / €25.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "LUGLIO",
          dettagli: {
            periodo: "1-31 LUGLIO (escluso il sabato e la domenica)",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€30.00 / €22.00",
                fila411: "€25.00 / €18.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€40.00 / €30.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€45.00 / €35.00",
              },
            ],
          },
        },
        {
          mese: "GIUGNO–LUGLIO Weekend",
          dettagli: {
            periodo: "SABATI E DOMENICHE DAL 1 GIUGNO AL 31 LUGLIO",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "AGOSTO",
          dettagli: {
            periodo: "1 - 31 AGOSTO (incluso il sabato e la domenica)",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€35.00 / €25.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€45.00 / €35.00",
                fila411: "€45.00 / €35.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€55.00 / €45.00",
              },
            ],
          },
        },
        {
          mese: "SETTEMBRE",
          dettagli: {
            periodo: "1 - 30 SETTEMBRE (escluso il sabato e la domenica)",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "SETTEMBRE Weekend",
          dettagli: {
            periodo: "SABATI E DOMENICHE DI SETTEMBRE",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "SETTEMBRE Finale Weekend",
          dettagli: {
            periodo: "SABATI E DOMENICHE DEL 20-28 SETTEMBRE",
            righe: [
              {
                tipo: "2 LETTINI + 1 OMBRELLONE",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LETTINI + 1 OMBRELLONE",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LETTINI + 1 OMBRELLONE",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
      ],
    },

    en: {
      title: "Rates",
      reservationTitle: "Reservation",
      priceNote:
        "I = Full day, M = Half day (8:00–13:00 or 13:30–18:30). Example: I: €20.00 M: €15.00",
      reservationHighlight:
        "You can reserve your place at the beach by visiting",
      points: [
        "In the 'Reservation' section you can access the map and select your desired umbrella.",
        "You can book until midnight of the previous day.",
        "Guaranteed place.",
        "Easy and intuitive umbrella selection.",
        "Advance payment by card.",
      ],
      months: [
        {
          mese: "MAY",
          dettagli: {
            periodo: "1–31 MAY (including Saturdays and Sundays)",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JUNE",
          dettagli: {
            periodo: "1–30 JUNE (excluding Saturdays and Sundays)",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€25.00 / €18.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€33.00 / €25.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JULY",
          dettagli: {
            periodo: "1–31 JULY (excluding Saturdays and Sundays)",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€30.00 / €22.00",
                fila411: "€25.00 / €18.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€40.00 / €30.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€45.00 / €35.00",
              },
            ],
          },
        },
        {
          mese: "JUNE–JULY Weekend",
          dettagli: {
            periodo: "SATURDAYS AND SUNDAYS FROM 1 JUNE TO 31 JULY",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "AUGUST",
          dettagli: {
            periodo: "1–31 AUGUST (including Saturdays and Sundays)",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€35.00 / €25.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€45.00 / €35.00",
                fila411: "€45.00 / €35.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€55.00 / €45.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER",
          dettagli: {
            periodo: "1–30 SEPTEMBER (excluding Saturdays and Sundays)",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER Weekend",
          dettagli: {
            periodo: "SATURDAYS AND SUNDAYS IN SEPTEMBER",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER Final Weekend",
          dettagli: {
            periodo: "SATURDAYS AND SUNDAYS FROM 20–28 SEPTEMBER",
            righe: [
              {
                tipo: "2 SUNBEDS + 1 UMBRELLA",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 SUNBEDS + 1 UMBRELLA",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 SUNBEDS + 1 UMBRELLA",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
      ],
    },

    fr: {
      title: "Tarifs",
      reservationTitle: "Réservations",
      priceNote:
        "I = Journée entière, M = Demi-journée (8h00–13h00 ou 13h30–18h30). Exemple : I : €20.00 M : €15.00",
      reservationHighlight:
        "Vous pouvez réserver votre place à la plage sur",
      points: [
        "Dans la section 'Réservations', accédez à la carte pour sélectionner le parasol souhaité.",
        "Réservation possible jusqu'à minuit la veille.",
        "Emplacement garanti.",
        "Sélection facile et intuitive du parasol.",
        "Paiement anticipé par carte.",
      ],
      months: [
        {
          mese: "MAI",
          dettagli: {
            periodo: "1–31 MAI (y compris les samedis et dimanches)",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JUIN",
          dettagli: {
            periodo: "1–30 JUIN (hors samedis et dimanches)",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€25.00 / €18.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€33.00 / €25.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JUILLET",
          dettagli: {
            periodo: "1–31 JUILLET (hors samedis et dimanches)",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€30.00 / €22.00",
                fila411: "€25.00 / €18.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€40.00 / €30.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€45.00 / €35.00",
              },
            ],
          },
        },
        {
          mese: "JUIN–JUILLET Weekend",
          dettagli: {
            periodo: "SAMEDIS ET DIMANCHES DU 1 JUIN AU 31 JUILLET",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "AOÛT",
          dettagli: {
            periodo: "1–31 AOÛT (y compris les samedis et dimanches)",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€35.00 / €25.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€45.00 / €35.00",
                fila411: "€45.00 / €35.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€55.00 / €45.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBRE",
          dettagli: {
            periodo: "1–30 SEPTEMBRE (hors samedis et dimanches)",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBRE Weekend",
          dettagli: {
            periodo: "SAMEDIS ET DIMANCHES DE SEPTEMBRE",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBRE Dernier Weekend",
          dettagli: {
            periodo: "SAMEDIS ET DIMANCHES DU 20–28 SEPTEMBRE",
            righe: [
              {
                tipo: "2 TRANSATS + 1 PARASOL",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 TRANSATS + 1 PARASOL",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 TRANSATS + 1 PARASOL",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
      ],
    },

    de: {
      title: "Preise",
      reservationTitle: "Reservierung",
      priceNote:
        "I = Ganztag, M = Halbtags (8:00–13:00 oder 13:30–18:30). Beispiel: I: €20.00 M: €15.00",
      reservationHighlight:
        "Sie können Ihren Platz am Strand reservieren unter",
      points: [
        "Im Abschnitt 'Reservierung' können Sie die Karte öffnen und Ihren gewünschten Sonnenschirm auswählen.",
        "Reservierung bis 24:00 Uhr am Vortag möglich.",
        "Garantierter Platz.",
        "Einfache und intuitive Auswahl des Sonnenschirms.",
        "Vorauszahlung mit Karte.",
      ],
      months: [
        {
          mese: "MAI",
          dettagli: {
            periodo: "1.–31. MAI (einschließlich Samstag und Sonntag)",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JUNI",
          dettagli: {
            periodo: "1.–30. JUNI (außer Samstag und Sonntag)",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€25.00 / €18.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€33.00 / €25.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "JULI",
          dettagli: {
            periodo: "1.–31. JULI (außer Samstag und Sonntag)",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€30.00 / €22.00",
                fila411: "€25.00 / €18.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€40.00 / €30.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€45.00 / €35.00",
              },
            ],
          },
        },
        {
          mese: "JUNI–JULI Wochenende",
          dettagli: {
            periodo: "SAMSTAG UND SONNTAG VOM 1. JUNI BIS 31. JULI",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "AUGUST",
          dettagli: {
            periodo: "1.–31. AUGUST (einschließlich Samstag und Sonntag)",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€35.00 / €25.00",
                fila411: "€35.00 / €25.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€45.00 / €35.00",
                fila411: "€45.00 / €35.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€55.00 / €45.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER",
          dettagli: {
            periodo: "1.–30. SEPTEMBER (außer Samstag und Sonntag)",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€20.00 / €15.00",
                fila411: "€20.00 / €15.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER Wochenende",
          dettagli: {
            periodo: "SAMSTAG UND SONNTAG IM SEPTEMBER",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€40.00 / €30.00",
                fila411: "€40.00 / €30.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€50.00 / €38.00",
              },
            ],
          },
        },
        {
          mese: "SEPTEMBER Letztes Wochenende",
          dettagli: {
            periodo: "SAMSTAG UND SONNTAG VOM 20.–28. SEPTEMBER",
            righe: [
              {
                tipo: "2 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€30.00 / €22.00",
                fila411: "€30.00 / €22.00",
              },
              {
                tipo: "3 LIEGEN + 1 SONNENSCHIRM",
                fila13: "€28.00 / €20.00",
                fila411: "€28.00 / €20.00",
              },
              {
                tipo: "4 LIEGEN + 1 SONNENSCHIRM",
                fila13: "X",
                fila411: "€38.00 / €30.00",
              },
            ],
          },
        },
      ],
    },
  };

  const t = translations[language];

  return (
    <div
      className="min-h-screen font-[chivo] bg-cover bg-center bg-no-repeat text-black"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="bg-white/80 min-h-screen">
        <NavbarWhite />

        <div className="pt-32 px-6 text-center">
          {/* Title + Language Toggle */}
          <div className="flex flex-col items-center justify-center mb-6">
            <div className="flex gap-4 mb-4">
              <img
                src={flagIT}
                alt="IT"
                onClick={() => setLanguage("it")}
                className={`w-8 h-8 cursor-pointer ${
                  language === "it" ? "opacity-100" : "opacity-40"
                }`}
              />

              <img
                src={flagEN}
                alt="EN"
                onClick={() => setLanguage("en")}
                className={`w-8 h-8 cursor-pointer ${
                  language === "en" ? "opacity-100" : "opacity-40"
                }`}
              />

              <img
                src={flagFR}
                alt="FR"
                onClick={() => setLanguage("fr")}
                className={`w-8 h-8 cursor-pointer ${
                  language === "fr" ? "opacity-100" : "opacity-40"
                }`}
              />

              <img
                src={flagDE}
                alt="DE"
                onClick={() => setLanguage("de")}
                className={`w-8 h-8 cursor-pointer ${
                  language === "de" ? "opacity-100" : "opacity-40"
                }`}
              />
            </div>

            <h1 className="text-4xl sm:text-5xl text-[#009FB7] font-bold">
              {t.title}
            </h1>

            {t.priceNote && (
              <p className="text-sm sm:text-base mb-6 text-gray-700">
                {t.priceNote.split(" ").map((word, idx) => {
                  if (word.startsWith("I:") || word === "I") {
                    return (
                      <span
                        key={idx}
                        className="font-bold text-red-600 mr-1"
                      >
                        {word}
                      </span>
                    );
                  } else if (word.startsWith("M:") || word === "M") {
                    return (
                      <span
                        key={idx}
                        className="font-bold text-red-600 mr-1"
                      >
                        {word}
                      </span>
                    );
                  } else {
                    return (
                      <span key={idx} className="mr-1">
                        {word}
                      </span>
                    );
                  }
                })}
              </p>
            )}
          </div>

          <div className="w-full max-w-7xl mx-auto px-4 mb-16">
            <h2 className="text-2xl font-bold text-[#FFC107] mb-6">
              {t.dailyPrices}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-lg px-2 justify-items-center">
              {t.months.map((item, idx) => (
                <div
                  key={idx}
                  className="border rounded-2xl p-6 shadow-lg bg-[#f8f8f8] font-semibold w-full sm:w-[400px] mx-auto min-h-[300px]"
                >
                  <div className="text-xl font-bold">
                    {item.mese.includes("Weekend") ? (
                      <>
                        <span className="text-[#009FB7]">
                          {item.mese.replace("Weekend", "").trim()}
                        </span>{" "}
                        <span className="text-red-600">Weekend</span>
                      </>
                    ) : (
                      <span className="text-[#009FB7]">{item.mese}</span>
                    )}
                  </div>

                  <div className="text-black text-2xl mt-1">
                    {item.prezzo}
                  </div>

                  {item.dettagli && (
                    <div className="mt-4 text-left text-sm">
                      <p className="font-bold text-[#009FB7] mb-2">
                        {item.dettagli.periodo}
                      </p>

                      <table className="w-full text-sm border border-gray-300">
                        <thead className="bg-[#e0f7fa]">
                          <tr>
                            <th className="border px-2 py-1 text-left w-[30%]">
                              Tipologia
                            </th>
                            <th className="border px-2 py-1 text-left w-[35%]">
                              FILA 1-3
                            </th>
                            <th className="border px-2 py-1 text-left w-[35%]">
                              FILA 4-11
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {item.dettagli.righe.map((row, idx) => (
                            <tr
                              key={idx}
                              className="bg-white even:bg-[#f7f7f7]"
                            >
                              <td className="border px-2 py-1 w-[30%]">
                                {row.tipo}
                              </td>

                              <td className="border px-2 py-1 w-[35%] leading-tight">
                                {row.fila13.includes(" / ") ? (
                                  <>
                                    <div>
                                      <span className="font-bold text-red-600">
                                        I:
                                      </span>{" "}
                                      {row.fila13.split(" / ")[0]}
                                    </div>

                                    <div>
                                      <span className="font-bold text-red-600">
                                        M:
                                      </span>{" "}
                                      {row.fila13.split(" / ")[1]}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div>
                                      <span className="font-bold text-red-600">
                                        I:
                                      </span>{" "}
                                      {row.fila13}
                                    </div>

                                    <div>
                                      <span className="font-bold text-red-600">
                                        M:
                                      </span>{" "}
                                      {row.fila13}
                                    </div>
                                  </>
                                )}
                              </td>

                              <td className="border px-2 py-1 w-[35%] leading-tight">
                                <div>
                                  <span className="font-bold text-red-600">
                                    I:
                                  </span>{" "}
                                  {row.fila411.split(" / ")[0]}
                                </div>

                                <div>
                                  <span className="font-bold text-red-600">
                                    M:
                                  </span>{" "}
                                  {row.fila411.split(" / ")[1]}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Highlight box */}
          <div className="max-w-4xl mx-auto text-left space-y-6">
            <div className="flex flex-col items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg py-6 px-4 text-center shadow-md">
              <img
                src={calendarioIcon}
                alt="Calendario"
                className="w-16 h-16 mb-4"
              />

              <p className="text-lg sm:text-xl text-[#009FB7] font-semibold">
                {t.reservationHighlight} <br />

                <a
                  href="https://www.lidodavittorio.it/prenota"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-[#007a91] text-black"
                >
                  www.lidodavittorio.it/prenota
                </a>
              </p>
            </div>

            {/* List of points */}
            <div className="grid gap-4">
              <div className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img
                  src={selezionaIcon}
                  alt="Mappa"
                  className="w-8 h-8 mr-3"
                />
                <p>{t.points[0]}</p>
              </div>

              <div className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img
                  src={okIcon}
                  alt="Prenota"
                  className="w-8 h-8 mr-3"
                />
                <p>{t.points[1]}</p>
              </div>

              <div className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img
                  src={okIcon}
                  alt="Posto"
                  className="w-8 h-8 mr-3"
                />
                <p>{t.points[2]}</p>
              </div>

              <div className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img
                  src={okIcon}
                  alt="Scelta"
                  className="w-8 h-8 mr-3"
                />
                <p>{t.points[3]}</p>
              </div>

              <div className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img
                  src={cartaIcon}
                  alt="Pagamento"
                  className="w-8 h-8 mr-3"
                />
                <p>{t.points[4]}</p>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default TariffeAbbonamenti;